import {AfterViewInit, Component, Inject, Renderer2} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {DOCUMENT} from '@angular/common';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit{
  private selector: string = 'initialState';

  title = 'WatchDog V2';
  constructor(@Inject(DOCUMENT) private _document: Document, private _renderer: Renderer2,) {}

  ngAfterViewInit() {
    this.removeElementById(this.selector);

  }

  private removeElementById(id: string): void {
    const element = this._document.getElementById(id);
    if (element && element.parentNode) {
      this._renderer.removeChild(element.parentNode, element);
    }
  }
}
